// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"484":"e75636b8","696":"67c1223b"}[chunkId] + ".chunk.js";
};